const salt = 'xJ7fTJBgQ55/9r|'

export default salt
